/**
 * Coordinates of a node
 */
type Coordinates = {
    x: number;
    y: number;
    width: number;
    height: number;
};

/**
 * Fish out coordinates from a performance entry.
 */
export function entryCoordinates(entry: PerformanceEntry): Coordinates {
    const node = entry.element || entry.target || entry.sources?.[0]?.node;
    const { x, y, width, height } = node?.getBoundingClientRect?.() || {};
    return [x, y, width, height].every(Number.isFinite)
        ? { x, y, width, height }
        : undefined;
}
